import { render, staticRenderFns } from "./DriverReturnDocumentList.vue?vue&type=template&id=5dbcc4cc&"
import script from "./DriverReturnDocumentList.vue?vue&type=script&lang=js&"
export * from "./DriverReturnDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports